var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "27px",
    viewBox: "0 0 45 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doc_share_page_0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc_share_page_0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOME",
    transform: "translate(-63.000000, -440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nieuwemap",
    transform: "translate(50.000000, 434.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(23.000000, 0.000000)",
    fill: "#332E20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.41315,6.65 C17.3166,6.65 18.05,7.3834 18.05,8.2878 L18.05,8.2878 L18.05,11.4 L32.56315,11.4 C33.4666,11.4 34.2,12.1334 34.2,13.0378 L34.2,13.0378 L34.2,30.6622 C34.2,31.5666 33.4666,32.3 32.56315,32.3 L32.56315,32.3 L5.4378,32.3 C4.5334,32.3 3.8,31.5666 3.8,30.6622 L3.8,30.6622 L3.8,13.0378 C3.8,12.1334 4.5334,11.4 5.4378,11.4 L5.4378,11.4 L7.86315,11.4 L7.86315,8.2878 C7.86315,7.3834 8.5956,6.65 9.5,6.65 L9.5,6.65 Z M31.35,14.25 L6.65,14.25 L6.65,29.45 L31.35,29.45 L31.35,14.25 Z M16.15095,8.55 L9.76315,8.55 L9.76315,11.4 L16.15095,11.4 L16.15095,8.55 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plus_klein",
    transform: "translate(13.000000, 14.000000)",
    fill: "#332E20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 0,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 4,
    width: 10,
    height: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCreate);
export default __webpack_public_path__ + "static/media/folderCreate.b02b0f2f83bbde224acd93a462c9016d.svg";
export { ForwardRef as ReactComponent };